export abstract class TodoPlannerBaseView {
  public todoValue = '';
}
